import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {ExpressCheckoutController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import ApplePayGateway from '../gateways/ApplePayGateway';

const settings = getSetting('ppcp_applepay_data');

const gateway = new ApplePayGateway({
    id: 'ppcp_applepay',
    cart,
    settings
});

const context = new Context('express_checkout');

const controller = new ExpressCheckoutController({
    id: 'ppcp_applepay',
    cart,
    context,
    gateway,
    settings
});

controller.initialize();